export const TagApi = ({color, backgroundColor, children}) => {

    return (
        <div style={{
            width:'60pt',
            height:'20pt',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            backgroundColor: backgroundColor,
            color: color,
            padding:'0 3pt',
            marginRight:'7pt',
            borderRadius:'2pt'
        }}>
            <span>{children}</span>
        </div>
    )
}